function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "user");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "user",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "User",
  transform: "translate(3.000000, 3.000000)"
}, React.createElement("circle", {
  id: "Oval",
  stroke: "currentColor",
  strokeWidth: 4,
  cx: 22,
  cy: 22,
  r: 22
}), React.createElement("path", {
  d: "M22.1809068,28 C29.4825662,28 35.8703396,32.0106319 39.3618135,38 L34.942176,38 C31.9429757,34.1752608 27.3408477,31.7272727 22.1809068,31.7272727 C17.0209658,31.7272727 12.4188378,34.1752608 9.4196376,38 L5,38 C8.4914739,32.0106319 14.8792473,28 22.1809068,28 Z",
  id: "Combined-Shape",
  fill: "currentColor",
  fillRule: "nonzero"
}), React.createElement("circle", {
  id: "Oval",
  stroke: "currentColor",
  strokeWidth: 4,
  cx: 22,
  cy: 20,
  r: 8
})));

var SvgUser = function SvgUser(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "50px",
    height: "50px",
    viewBox: "0 0 50 50",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgUser, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/user.cc29737f.svg";
export { ForwardRef as ReactComponent };